module.exports = __webpack_public_path__ + "static/media/watch.c35cb7f5.gif";